import { OAuthErrorContent, OAuthLayout } from '@features/OAuth';

export default function OAuthErrorPage() {
  return (
    <OAuthLayout>
      <OAuthErrorContent />
    </OAuthLayout>
  );
}
